export const
    //API_URL = "//s2008/MOZ_API_INTERNAL_2/",
    API_URL ="//91.192.197.141:8888/MOZ_API/",  //wersja żywa MOZ_SITE external
    //API_URL = "http://localhost:4000",
    //API_URL = "//localhost:62398/",
    ///API_URL = "http://proiis/MOZ_API_Internal/", //wersja internal MOZ_SITE_internal 
    IS_INTERNAL_APP = false; //internat TRUE; external FALSE
